(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FLAG_guidelines-page"] && !Shopify.designMode) return;
  try {
    

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

document.getElementById('scrollTopBtn').addEventListener('click', function(e) {
    e.preventDefault();
    scrollToTop();
});

document.querySelector(".sidebar__menu li a").addEventListener("click", function(e) {
    e.preventDefault();
    scrollToTop();
});

document.querySelectorAll('.table-contents_element .element').forEach(element => {
    element.addEventListener('click', function(e) {
        e.preventDefault();

        document.querySelectorAll('.guidelines-page_element .title.active').forEach(active => {
            active.classList.remove('active');
        });

        const href = this.getAttribute('href');
        const targetElement = document.querySelector(href);

        if (targetElement) {
            targetElement.classList.add('active');

            let offset = 250;
            if (window.innerWidth <= 949) {
                offset = 350;
            } 
            if (window.innerWidth <= 767) {
                offset = 310;
            }

            window.scroll({
                top: targetElement.offsetTop - offset,
                behavior: 'smooth'
            });
        }
    });
});

const scrollToTopLink = document.getElementById('scroll-to-top');
if (scrollToTopLink) {
    scrollToTopLink.addEventListener('click', function(e) {
        e.preventDefault();
        scrollToTop();
    });
}



// 英数字のみフォント変更

const nodeIterator = document.createNodeIterator(
    document.getElementById('page-content'),
    NodeFilter.SHOW_TEXT,
    null
);

let currentNode;
while (currentNode = nodeIterator.nextNode()) {
    if (!hasAncestorWithClass(currentNode, 'alphabet')) {
        let parent = currentNode.parentElement;
        while (parent && parent !== document.body) {
            if (parent.tagName === 'p' || parent.tagName === 'a' || hasNotoClassAncestor(parent)) {
                const template = document.createElement('template');
                template.innerHTML = currentNode.nodeValue.replace(/(\w+)/g, '<span class="alphabet">$1</span>');
                currentNode.parentElement.insertBefore(template.content, currentNode);
                currentNode.parentElement.removeChild(currentNode);
                break;
            }
            parent = parent.parentElement;
        }
    }
}

function hasAncestorWithClass(node, className) {
    while (node = node.parentElement) {
        if (node.classList.contains(className)) {
            return true;
        }
    }
    return false;
}

function hasNotoClassAncestor(node) {
    while (node = node.parentElement) {
        if (node.classList.contains('caption-notoserif') || node.classList.contains('caption-notosans')) {
            return true;
        }
    }
    return false;
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar"]) return;
  try {
    
  
  
if (location.pathname === '/') {
    window.addEventListener("scroll", function () {
        const elm = document.querySelector(".sidebar");
        const scroll = window.pageYOffset;
        let displayThreshold;
        // メディアクエリを使用してデバイスタイプを判定
        if (window.matchMedia("(max-width: 768px)").matches) {
            // スマートフォン（iPad miniもここに含む）
            displayThreshold = window.innerHeight * 0.15;
        } else if (window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches) {
            // タブレット（iPad miniを除く）
            displayThreshold = window.innerHeight * 0.1; // タブレット用の閾値を設定
        } else {
            // PC
            displayThreshold = window.innerHeight * 0.2;
        }
        // スクロール位置に基づいて .sidebar の表示を制御
        if (scroll > displayThreshold) {
            elm.style.opacity = "1";
            elm.style.zIndex = "1";
        } else {
            elm.style.opacity = "0";
            elm.style.zIndex = "-1";
        }
    });
};



  

  

  } catch(e) { console.error(e); }
})();
})();
